export function propertyByFeature(feature, property, map_data) {
  //   console.log(feature, "feature");
  //   console.log(property, "property");
  //   console.log(map_data, "map_data");

  var language = 1;
  try {
    var rruga = _.find(
      map_data.note_data_to_pay != undefined
        ? map_data.note_data_to_pay.rruget
        : null,
      (rruga, i) => {
        if (!feature.properties.rruga_kodi) {
          return;
        }
        return rruga.rruga_kodi === feature.properties.rruga_kodi;
      }
    );

    var kategoria_prop =
      feature.properties.kategoria != undefined
        ? feature.properties.kategoria
        : null;

    var metaid_prop =
      feature.properties.metaid != undefined ? feature.properties.metaid : null;

    if (property === "color") {
      var color = "";
      if (kategoria_prop) {
        color = map_data.kategorite["kategori_" + kategoria_prop].color;
      } else {
        color = map_data.kategorite["kategori_1"].color;
      }
      return color;
    } else if (property === "iconUrl") {
      var iconUrl = "";
      if (kategoria_prop) {
        iconUrl = map_data.kategorite["kategori_" + kategoria_prop].icon;
      } else {
        iconUrl = map_data.kategorite["kategori_1"].icon;
      }
      return iconUrl;
    } else if (property === "zap") {
      var zap = "";
      if (metaid_prop) {
        var metaid = metaid_prop;
        var meta = map_data.metadata["meta_" + metaid];
        zap = meta.zap;
      } else {
        zap = rruga.zona_kodi;
      }
      return zap;
    } else if (property === "price") {
      var cmimi = _.filter(map_data.cmimet, cmimi => {
        if (!rruga) {
          return;
        }
        return rruga.zona_kodi === cmimi.zona_kodi;
      });
      return cmimi || [];
    } else if (property === "free") {
      var free = "";
      if (metaid_prop) {
        var metaid = metaid_prop;
        var meta = map_data.metadata["meta_" + metaid];
        free = meta.free;
      } else {
        free = rruga.perqindja_pa_pagese;
      }
      return free;
    } else if (property === "paid") {
      var paid = "";
      if (metaid_prop) {
        var metaid = metaid_prop;
        var meta = map_data.metadata["meta_" + metaid];
        paid = meta.paid;
      } else {
        paid = rruga.perqinda_me_pagese;
      }
      return paid;
    } else if (property === "rruga") {
      var emri_rruga = "";
      if (metaid_prop) {
        var metaid = metaid_prop;
        var meta = map_data.metadata["meta_" + metaid];
        emri_rruga = meta.rruga;
      } else {
        emri_rruga = rruga.rruga_emertimi;
      }
      return emri_rruga;
    } else if (property === "description") {
      var description = "";
      if (metaid_prop) {
        var metaid = metaid_prop;
        var meta = map_data.metadata["meta_" + metaid];
        description = meta.description;
      }

      return description;
    } else if (property === "parkingtype") {
      var parkingtype = "";
      if (feature.properties.kategoria) {
        var categoryid = feature.properties.kategoria;
        //   var category = map_data.kategorite["kategori_" + categoryid];
        parkingtype =
          map_data.kategorite["kategori_" + categoryid]["name" + language];
      } else {
        parkingtype = map_data.kategorite["kategori_1"]["name" + language];
      }
      return parkingtype;
    } else if (property === "capacity") {
      var capacity = "";
      if (metaid_prop) {
        var metaid = metaid_prop;
        var meta = map_data.metadata["meta_" + metaid];
        capacity = meta.capacity;
      } else {
        capacity = rruga.rruga_nr_vende_parkim;
      }
      return capacity;
    }
  } catch (error) {
    return;
  }
}
